import React from 'react'
import { CreateSupportAnnounce6Container } from '../../containers/Officer/CreateSupportAnnounce6Container'
export const CreateSupportAnnounce6Page = () => {
    return (
        <CreateSupportAnnounce6Container />
    )
}
